<template>
    <div>
        <ul class="list-group">
            <li class="list-group-item d-flex justify-content-between text-nowrap px-50 py-25"><strong>Dosya Adı</strong><span>{{ row.FileName || 'Bilinmiyor' }}</span></li>
            <li class="list-group-item d-flex justify-content-between text-nowrap px-50 py-25"><strong>Ödeme Tarihi</strong><span>{{ row.DateStr || 'Bilinmiyor' }}</span></li>
            <li class="list-group-item d-flex justify-content-between text-nowrap px-50 py-25"><strong>Oluşturulma Tarihi</strong><span>{{ row.CreateTimeStr || 'Bilinmiyor' }}</span></li>
            <li class="list-group-item d-flex justify-content-between text-nowrap px-50 py-25"><strong>Güncellenme Tarihi</strong><span>{{ row.UpdateTimeStr || 'Bilinmiyor' }}</span></li>
            <li class="list-group-item d-flex justify-content-between text-nowrap px-50 py-25"><strong>TMS Toplam Tutar <feather-icon class="text-warning ml-50 mb-20" icon="InfoIcon" v-b-tooltip.noninteractive.hover.bottom="'TMS\'deki son güncel tutar'"></feather-icon></strong><span>{{ row.TMSTotalAmountStr || 'Bilinmiyor' }}</span></li>
            <li class="list-group-item d-flex justify-content-between text-nowrap px-50 py-25"><strong>TMS Toplam Kayıt</strong><span>{{ row.Count || 'Bilinmiyor' }}</span></li>
        </ul>
        <template v-if="($safe(row,'Description') || []).length && ($safe(row,'StatusId')||[])!=10">
            <h6 class="mt-75 text-secondary">Açıklamalar</h6>
            <ul class="list-group">
                <li v-for="(desc,i) in ($safe(row,'Description') || [])" class="list-group-item px-50 py-25">
                    {{ desc }}
                </li>
            </ul>
        </template>
    </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue'

export default {
    props:{
        row:Object,
        field:Object
    },
    directives:{
        'b-tooltip':VBTooltip
    }
}
</script>

<style>

</style>